import axios from '../util/axios';
import Token from '../util/Token';

const BASE_URL = '/cms/v1/team';

// Get live charging status overview
async function getLiveChargingStatus(teamId, params = {}) {
  try {
    Token.setAuthToken();
    const response = await axios.get(`${BASE_URL}/${teamId}/charging-status`, {
      params: {
        includeDetails: true,
        statusFilter: 'all',
        ...params
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching live charging status:', error);
    throw error;
  }
}

// Get specific station details
async function getStationDetails(teamId, stationId) {
  try {
    Token.setAuthToken();
    const response = await axios.get(`${BASE_URL}/${teamId}/charging-status/${stationId}`);
    return response.data;
  } catch (error) {
    console.error('Error fetching station details:', error);
    throw error;
  }
}

// Update station status (manual override)
async function updateStationStatus(teamId, stationId, statusData) {
  try {
    Token.setAuthToken();
    const response = await axios.put(`${BASE_URL}/${teamId}/charging-status/${stationId}/status`, statusData);
    return response.data;
  } catch (error) {
    console.error('Error updating station status:', error);
    throw error;
  }
}

// Get status history
async function getStatusHistory(teamId, params = {}) {
  try {
    Token.setAuthToken();
    const response = await axios.get(`${BASE_URL}/${teamId}/charging-status/history`, {
      params: {
        limit: 100,
        offset: 0,
        ...params
      }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching status history:', error);
    throw error;
  }
}

// Real-time updates disabled - users must refresh manually

const liveChargingService = {
  getLiveChargingStatus,
  getStationDetails,
  updateStationStatus,
  getStatusHistory
};

export default liveChargingService;
